module.exports = __webpack_public_path__ + "img/top.eba1e0c7.png";